import { Tween, Easing } from '@tweenjs/tween.js';
import { getCurrencySymbol } from '../helper/currencies';
import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import { isDesktop } from 'react-device-detect';
// import { Graphics, Sprite, Texture } from 'pixi.js';
// import * as PIXI from 'pixi.js'
class BalanceController {
	currentData = null;
	constructor(vc, conf) {
		this.vc = vc;
		this.configs = conf;
		// this.balance = GameConfigs.config.balance
		this.balance = GameConfigs.auth.balance.amount;
		// this.currency = getCurrencySymbol(G.GameConfigs.config.currency)
		this.currency = getCurrencySymbol(GameConfigs.auth.balance.currency);
		this.vc[this.configs.holder].Balance.BALANCE_VALUE.text = '';
		this.BALANCE_LABEL = this.vc[this.configs.holder].Balance.BALANCE_LABEL;
		this.BALANCE_VALUE = this.vc[this.configs.holder].Balance.BALANCE_VALUE;

		// this.bg = new Graphics();
		// this.bg.clear();
		// this.bg.beginFill(0xe5a7dd);
		// this.vc[this.configs.holder].Balance.addChild(this.bg);
		// this.bg.drawRoundedRect(0, 0, window.innerWidth * window.CurrentSize.s, 100, 0);
		// console.log(GameConfigs,1920 * window.CurrentSize.s,  'io');

		// this.bg.x = 0;
		// this.bg.y = 0;
		// console.log(this.vc, 'this vc');

		const formattedBalance = (+this.balance).toLocaleString(undefined, {
			minimumFractionDigits: GameConfigs.config.currency_prec,
			maximumFractionDigits: GameConfigs.config.currency_prec
		});

		let finalAmount;

		if (this.currency[1] === 'left') {
			this.vc[this.configs.holder].Balance.BALANCE_VALUE.text =
				this.currency[0] + formattedBalance;
		} else {
			if (GameConfigs.auth.balance.currency === 'GEL') {
				finalAmount = formattedBalance + this.currency[0];
			} else {
				finalAmount = formattedBalance + ' ' + this.currency[0];
			}
			this.vc[this.configs.holder].Balance.BALANCE_VALUE.text = finalAmount;
		}

		window.addEventListener(
			EVENTS.SERVER_MSG,
			this.serverMessage.bind(this),
			false
		);
		window.addEventListener(
			EVENTS.MAIN_LINE_FINISHED,
			this.lineAllfinished.bind(this),
			false
		);

		this.BALANCE_LABEL.anchor.x = 0;
		this.BALANCE_VALUE.anchor.x = 0;
		this.setBalance();
	}

	resize(w, h) {
		// this.bg.clear();
		// this.bg.beginFill(0xe5a7dd);
		// this.vc[this.configs.holder].Balance.addChild(this.bg);
		// this.bg.drawRoundedRect(0, 0,  window.CurrentSize.w, 100, 0);
		if (!isDesktop) {
			if (w >= h) {
				this.BALANCE_LABEL.style.fontSize = 26;
				this.BALANCE_VALUE.style.fontSize = 30;
				this.BALANCE_LABEL.y = -50;
				this.BALANCE_VALUE.y = -24;
			} else {
				this.BALANCE_LABEL.style.fontSize = 16;
				this.BALANCE_VALUE.style.fontSize = 18;
				this.BALANCE_LABEL.y = 12;
				this.BALANCE_VALUE.y = 29;
				this.BALANCE_LABEL.x = 12;
				this.BALANCE_VALUE.x = 12;
			}
		} else {
			this.BALANCE_LABEL.style.fontSize = 16;
			this.BALANCE_VALUE.style.fontSize = 18;
			this.BALANCE_LABEL.y = -10;
			this.BALANCE_VALUE.y = 7;
			this.BALANCE_LABEL.x = 12;
			this.BALANCE_VALUE.x = 12;
		}
	}

	serverMessage(e) {
		switch (e.detail.service) {
			case 'bet':
				// case 'bonusstep':
				// case 'freespinstep':
				this.currentData = e.detail.data;
				GameConfigs.auth.balance.amount = e.detail.data.balance;
				this.updateBalance(e.detail.data.balancebefore);
				break;
			case 'bonusstep':
			case 'freespinstep':
				this.currentData = e.detail.data;
				GameConfigs.auth.balance.amount = e.detail.data.balance;
				// this.updateBalance(e.detail.data.balancebefore);
				break;
			default:
				break;
		}
	}

	lineAllfinished() {
		if (this.currentData) {
			this.updateBalance(this.currentData.balance);
			this.currentData = null;
		}
	}

	setBalance() {
		const formattedBalance = (+this.balance).toLocaleString(undefined, {
			minimumFractionDigits: GameConfigs.config.currency_prec,
			maximumFractionDigits: GameConfigs.config.currency_prec
		});
		let finalAmount;
		if (this.currency[1] === 'left') {
			this.vc[this.configs.holder].Balance.BALANCE_VALUE.text =
				this.currency[0] + formattedBalance;
		} else {
			if (GameConfigs.auth.balance.currency === 'GEL') {
				finalAmount = formattedBalance + this.currency[0];
			} else {
				finalAmount = formattedBalance + ' ' + this.currency[0];
			}
			this.vc[this.configs.holder].Balance.BALANCE_VALUE.text = finalAmount;
		}
	}

	updateBalance(balance) {
		this.tweener = new Tween(this)
			.to({ balance: balance }, 500)
			.easing(Easing.Linear.None)
			.onUpdate(() => {
				this.setBalance();
			})
			.start();
	}
}

export default BalanceController;
